import { CameraSwitchIcon } from './CameraSwitchIcon';

/**
 * author: Google
 * id 68BB6884-5CEA-4B2A-8F22-46B6A98CDA75
 * name camera-switch
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/camera-switch.svg
 * tags
 * - Photography 
 */
export const SwitchCameraIcon = CameraSwitchIcon;
export default SwitchCameraIcon